/* storybook-check-ignore */
const ChevronLeftBold = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7356 5.73563C13.7771 4.77707 12.2229 4.77707 11.2644 5.73563L6.25034 10.7497C5.29178 11.7082 5.29178 13.2623 6.25034 14.2209L11.2644 19.2349C12.2229 20.1935 13.7771 20.1935 14.7356 19.2349C15.6942 18.2764 15.6942 16.7222 14.7356 15.7637L11.4572 12.4853L14.7356 9.20688C15.6942 8.24832 15.6942 6.69419 14.7356 5.73563Z"
      fill="#222222"
    />
  </svg>
);

export default ChevronLeftBold;
